export default "__VITE_ASSET__gp$pamXs__"